export default "dist/images/components-design-separator-control-curve-2.4b8c7da.png";